import { format } from 'date-fns'
import { pt } from 'date-fns/locale'
import { CircleMinus, Clock, PlusCircle, Search, Trash, User } from 'lucide-react'
import { useState } from 'react'
import { Button } from '../../../../components/ui/button'
import { Input } from '../../../../components/ui/input'
import { ScrollArea } from '../../../../components/ui/scroll-area'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../../components/ui/table'
import { DeleteSession } from '../actions/delete-session'
import { ManageMemberSession } from '../actions/manage-member-session'

interface EventModalProps {
  calendarEvent: any
}

export function EventModal({ calendarEvent }: EventModalProps) {
  const [modal, setModal] = useState(false)

  const [inputFilter, setInputFilter] = useState('')

  const { start, end, title, data, id } = calendarEvent
  const cashfitFields = data as any

  const { findMember, membersFiltred, addMember, removeMember, loadMembersAdded, members } = ManageMemberSession({ sessionId: id })

  const handleDelete = async () => {
    await DeleteSession(id)
    cashfitFields.reloadSession()
  }

  return (
    <div className="shadow rounded-md p-4">
      {modal && (
        <div className="left-0 top-0 bg-black/30 w-full h-full fixed flex items-center justify-center gap-2">
          <div className="p-6 bg-white rounded-md shadow-md w-1/5 h-2/3 flex flex-col gap-2">
            <div className="flex gap-2  items-center">
              <Input placeholder="Pesquisar aluno" onChange={(e) => setInputFilter(e.target.value)} value={inputFilter} />
              <Button className="hover:bg-cashfit-green-200 transition-all " style={{ backgroundColor: '#ee7101' }} onClick={() => findMember(inputFilter)}>
                <Search />
              </Button>
            </div>

            <ScrollArea className="h-[400px]">
              <Table className="w-full h-1/2">
                <TableHeader>
                  <TableRow>
                    <TableHead className="w-[100px]">Aluno</TableHead>
                    <TableHead className="text-right">ações</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {membersFiltred.map((invoice: any) => (
                    <TableRow key={invoice.id}>
                      <TableCell className="font-medium">
                        <div className="w-[100px] overflow-hidden truncate ...">{invoice.nome}</div>
                      </TableCell>
                      <TableCell className="font-medium flex justify-end w-full">
                        <PlusCircle className="bg-acelerafit-green-200 h-6 rounded-md  cursor-pointer shadow-md text-muted p-1" onClick={() => addMember(id, invoice.id)} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </ScrollArea>
          </div>

          <div className="p-6 bg-white rounded-md shadow-md w-2/4 h-2/3 flex flex-col gap-2">
            <h3 className="font-bold text-2xl  mb-2">{cashfitFields.nome}</h3>
            <p>
              <strong>Sala:</strong>{` ${cashfitFields.nomeSala} - Nº ${cashfitFields.numeroSala}`}
            </p>
            <p>
              <strong>Descrição:</strong> {cashfitFields.descricao}
            </p>

            <p>
              <strong>Observações:</strong> {cashfitFields.observacao}
            </p>

            <div className="flex gap-2 items-center">
              <User height={14} /> alunos
              <span>{`${cashfitFields.quantidadeAlunosInscritos} / ${cashfitFields.capacidadeMaxima}`}</span>
            </div>
            <ScrollArea className="min-h-96">
              <Table className="w-full h-1/2">
                <TableHeader>
                  <TableRow>
                    <TableHead className="w-[200px]">Aluno</TableHead>

                    <TableHead className="text-right">ação</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {members.map((invoice: any) => (
                    <TableRow key={invoice.id}>
                      <TableCell className="font-medium  w-8">
                        <div className="w-[300px] overflow-hidden truncate ...">{invoice.nome}</div>
                      </TableCell>
                      <TableCell className="font-medium flex justify-end w-full">
                        <CircleMinus className="bg-acelerafit-green-200  h-6 rounded-md  cursor-pointer shadow-md text-muted p-1" onClick={() => removeMember(invoice.id)} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </ScrollArea>
            <div className="flex justify-end">
              <Button onClick={() => setModal(false)} variant="outline">
                Fechar
              </Button>
            </div>
          </div>
        </div>
      )}

      <div className="text-md font-bold">{title}</div>
      <span className='pl-1'>{`Sala: ${cashfitFields.nomeSala} - Nº ${cashfitFields.numeroSala}`}</span>
      <div className="flex gap-2 items-center ">
        <Clock height={14} />
        <span className="">
          {format(new Date(start), 'dd/MM HH:mm', { locale: pt })}  {'até'} {format(new Date(end), 'dd/MM HH:mm', { locale: pt })}
        </span>
      </div>

      <div className="flex gap-2 items-center">
        <User height={14} />
        <span>{`${cashfitFields.quantidadeAlunosInscritos} / ${cashfitFields.capacidadeMaxima}`}</span>
      </div>
      <div className="flex gap-2">
        <div
          className="mt-1 bg-acelerafit-green-50  hover:bg-acelerafit-green-400 transition-all rounded-md w-32 flex items-center justify-center cursor-pointer font-bold shadow-md"
          onClick={() => {
            setModal(true)
            loadMembersAdded()
          }}
        >
          Ver mais
        </div>
        <Button className="shadow mt-1 text-red-700 hover:text-white" variant={'destructive'} onClick={handleDelete}>
          <Trash className="" />
        </Button>
      </div>
    </div>
  )
}
